import React, { Component } from 'react';

// Components
import ShelfStatusIcon from '../../../components/shelf-management/ShelfStatusIcon';

// Libraries
import classNames from 'classnames';

// Types
import ThemeMode from '@/types/theme-mode';
import User from '@/types/user';

// Utils
import { CONTACT_LAYOUT } from '../../../../utils/contacts';
import { formatMessage } from '../../../../utils/i18n';
import { userHasPermissionEnabled, PERMISSIONS } from '../../../../utils/permissions';

export enum COMPARISONS_FILTER {
  ASSIGNED = 'assigned',
  COMPLIANCE = 'compliance',
  DRAFTS = 'drafts',
  RECENT = 'recent',
}

type Props = {
  user: User;
  selected: COMPARISONS_FILTER;
  onChange: (value: COMPARISONS_FILTER) => void;
  contactLayout: CONTACT_LAYOUT;
};

type option = {
  icon?: string;
  iconComponent?: React.JSX.Element;
  hidden?: boolean;
  label: string;
  value: COMPARISONS_FILTER;
};

class ComparisonsFilterNavigation extends Component<Props> {
  getFilterOptions = () => {
    const { user, contactLayout } = this.props;
    const { theme } = user.preferences ?? { theme: ThemeMode.DEFAULT };

    let options: option[] = [];

    // This is part of the Correlate light theme update.
    // Note that the current "dark" page is meant to be removed completely.
    // This would become the options for all users.
    if (theme === ThemeMode.LIGHT) {
      options = [
        {
          label: formatMessage('ComparisonHome.Filters.All'),
          value: COMPARISONS_FILTER.RECENT,
        },
        {
          label: formatMessage('ComparisonHome.Filters.Drafts'),
          value: COMPARISONS_FILTER.DRAFTS,
        },
        {
          label: formatMessage('ComparisonHome.Filters.Assigned'),
          value: COMPARISONS_FILTER.ASSIGNED,
        },
        {
          label: formatMessage('ComparisonHome.Filters.ComplianceShort'),
          value: COMPARISONS_FILTER.COMPLIANCE,
          hidden: !userHasPermissionEnabled(user, PERMISSIONS.KYP) || userHasPermissionEnabled(user, PERMISSIONS.KYP_COMPARISONS_SAVED_TO_AUTH_USER),
        },
      ];
    } else {
      // These are the current "dark" page options
      // Should be removed in the future.
      // Note the contactLayout won't be needed here anymore once this part is removed :
      options = [
        {
          icon: 'icon-clock',
          label: formatMessage('ComparisonHome.Filters.Recent'),
          value: COMPARISONS_FILTER.RECENT,
        },
        {
          icon: 'icon-user-2',
          label:
            contactLayout === CONTACT_LAYOUT.CLIENT
              ? formatMessage('ComparisonHome.Filters.SavedToClient')
              : formatMessage('ComparisonHome.Filters.SavedToContact'),
          value: COMPARISONS_FILTER.ASSIGNED,
        },
        {
          icon: 'icon-triple-bars',
          label: formatMessage('ComparisonHome.Filters.Drafts'),
          value: COMPARISONS_FILTER.DRAFTS,
        },
        {
          iconComponent: <ShelfStatusIcon className="compliance-comparison-filter" />,
          label: formatMessage('ComparisonHome.Filters.Compliance'),
          value: COMPARISONS_FILTER.COMPLIANCE,
          hidden: !userHasPermissionEnabled(user, PERMISSIONS.KYP) || userHasPermissionEnabled(user, PERMISSIONS.KYP_COMPARISONS_SAVED_TO_AUTH_USER),
        },
      ];
    }

    return options.filter(option => !option.hidden);
  };

  onOptionClick = (value: COMPARISONS_FILTER) => {
    this.props.onChange(value);
  };

  render() {
    const { selected } = this.props;

    return (
      <div className="comparisons-filter-navigation navigation navigation-pills">
        {this.getFilterOptions().map(option => (
          <button
            className={classNames('filter-item', { active: option.value === selected })}
            type="button"
            key={option.value}
            onClick={() => this.onOptionClick(option.value)}
          >
            {option.icon && <i className={option.icon} />}
            {option.iconComponent}

            <span>{option.label}</span>
          </button>
        ))}
      </div>
    );
  }
}

export default ComparisonsFilterNavigation;
